

var Roles = function()
{

    var _this = this;

    var container = $('[javascript="edit-role"]');

    var onFilterKeyUpHandler = function(e)
    {
        var value = $.fn.ensphere.veto.slugify( $(this).val() );
        if( value ) {
            $('[data-filter]').hide();
            $('[data-filter*="' + value + '"]').show();
            $('.check-all, .uncheck-all' ).each(function(){
                if( $( '[data-filter]:visible', $(this) ).length ) {
                    $(this).parent().show();
                } else {
                    $(this).parent().hide();
                }
            });
        } else {
            $('[data-filter]').show();
            $('.check-all, .uncheck-all' ).parent().show();
        }
    };

    var onClickCheckAllHandler = function(e)
    {
        e.preventDefault();
        var panel = $(this).parents('.x_panel:eq(0)');
        var checkBoxes = $('input', panel);
        if( panel.hasClass( 'uncheck-all' ) ) {
            checkBoxes.iCheck('uncheck');
            panel.removeClass( 'uncheck-all' ).addClass( 'check-all' );
        } else {
            checkBoxes.iCheck('check');
            panel.removeClass( 'check-all' ).addClass( 'uncheck-all' );
        }
    };

    var bindEvents = function()
    {
        _this.api.filter.on( 'keyup', onFilterKeyUpHandler );
        _this.api.checkAllToggles.on( 'click', onClickCheckAllHandler );
    };

    var setCheckAllClasses = function()
    {
        _this.api.checkAllToggles.each( function(){
            var panel = $(this).parents('.x_panel:eq(0)');
            if( $('input:not(:checked)', panel ).length ) {
                panel.addClass( 'check-all' );
            } else {
                panel.addClass( 'uncheck-all' );
            }
        });
    };


    this.api = {

        filter: $( '[data-for="filtering"]', container ),
        checkAllToggles: $( '[data-for="check-all-toggle"]', container ),

        instantiable: function() {
            return container.length;
        },

        init: function() {
            bindEvents();
            setCheckAllClasses();
        }
    };

    return this.api;

};

$(function() {
    var api = new Roles();
    if( api.instantiable() ) {
        api.init();
    }
});
